import type { AuthUser, Role } from '../api/types'

/** Backend confirmed: GET /employees/:id/sessions and /summary filter to the caller's site_ids
 * for SITE_MANAGER (EmployeeQueries.cs). This is the single switch that keeps the route roles,
 * the employee links, and the client-side site filter all in sync. */
export const EMPLOYEE_SESSIONS_SITE_SCOPED = true

export const homePathFor = (role: Role) => (role === 'SUPER_ADMIN' ? '/super' : role === 'RESELLER' ? '/reseller' : '/dashboard')

export const canViewSite = (user: AuthUser, siteId: string) =>
  user.role === 'ADMIN' || (user.role === 'SITE_MANAGER' && user.siteIds.includes(siteId))

export const canViewEmployees = (user: AuthUser) => user.role === 'ADMIN' || (user.role === 'SITE_MANAGER' && EMPLOYEE_SESSIONS_SITE_SCOPED)

/** Jobs and shifts: admins anywhere, site managers at their own sites (with any active employee). The API
 * enforces the site scope (RosterAccess.cs); GET /sites is already scoped, so site pickers need no extra filter. */
export const canEditRoster = (user: AuthUser) => user.role === 'ADMIN' || user.role === 'SITE_MANAGER'

export const employeeDetailRoles = (): readonly Role[] => (EMPLOYEE_SESSIONS_SITE_SCOPED ? ['ADMIN', 'SITE_MANAGER'] : ['ADMIN'])
